import { getData } from "@/utils/fetch";
import debounce from "debounce-promise";
import { defineStore } from "pinia";

let debouncedFetch = debounce(getData, 500);

export const usesgnksoStore = defineStore({
  id: "sgnkso",
  state: () => ({
    sgnkso: {},
  }),
  getters: {
    getData(state) {
      return state.sgnkso.data;
    },
  },
  actions: {
    async getAllsgnkso(params) {
      this.sgnkso = { loading: true };
      const dataparams = {
        limit: params?.limit || 50,
        offset: params?.offset || 0,
        order: params?.order || "short_uuid",
        ordertype: params?.ordertype || "ASC",
        q: params?.q,
      };

      try {
        const result = await debouncedFetch("sgn_kso", dataparams);
        this.sgnkso = { ...result.data };
      } catch (error) {
        console.log(error);
        this.sgnkso = { error };
      }
    },
  },
});
